import { render, staticRenderFns } from "./bmgl.vue?vue&type=template&id=1243cc9f&"
import script from "./bmgl.vue?vue&type=script&lang=js&"
export * from "./bmgl.vue?vue&type=script&lang=js&"
import style0 from "./bmgl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports